import React, { useEffect, useState } from 'react'
import intl from 'react-intl-universal'
import { LogModal } from './log-modal'
import CircularProgress from '@material-ui/core/CircularProgress'
import Fetch from 'utils/fetch'
import CircleLine from 'images/checkbox-circle-line.svg'
import { useGlobalContext } from 'hooks/useGlobalContext'
import * as S from './styled'
import PropTypes from 'prop-types'

export const OperationProgress = ({ requests, text, callback = null }) => {
  const { endOperation } = useGlobalContext()
  const [inProgress, setInProgress] = useState(true)
  const [finished, setFinished] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [numberOf, setNumberOf] = useState(0)
  const [log, setLog] = useState([])
  const [showLogModal, setShowLogModal] = useState(false)
  const [progress, setProgress] = useState(0)
  const [transition, setTransition] = useState(false)

  const totalItems = requests.reduce((count, request) => count + (request.suggestionIds?.length || 1), 0)
  const getAllSuccess = () => numberOf === totalItems && log.length === 0

  const getAnyFailed = () =>
    log.length > 0

  const timer = (fn, value, time) => setTimeout(() => {
    fn(value)
  }, time)

  const closeLogModal = () => {
    endOperation()
    setShowLogModal(false)
  }

  useEffect(() => {
    if (transition) {
      timer(endOperation, null, 500)
    }
    return () => clearTimeout(timer)
  }, [transition])


  useEffect(() => {
    if (getAllSuccess()) {
      setShowTooltip(true)
      timer(setTransition, true, 4500)
      return () => clearTimeout(timer)
    }
  }, [finished])

  useEffect(() => {
    if (log.length > 0 || finished) {
      setShowTooltip(true)
    }
  }, [showTooltip])

  useEffect(() => {
    setShowTooltip(true)
    timer(setShowTooltip, false, 5000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const request = async () => {
      const results = [];
      const failures = [];
      let completed = 0;

      for (let n = 0; n < requests.length; n++) {
        const { method, API, body, errorId, suggestionIds = [errorId] } = requests[n]

        try {
          const response = await Fetch[method](API, body)
          const responseBody = response?.data ?? response
          const requestResults = responseBody?.Results ?? responseBody?.results
          if (API === 'suggestions:accept' && Array.isArray(requestResults)) {
            results.push(...requestResults)
            const idOf = (result) => result.SuggestionId ?? result.suggestionId
            const statusOf = (result) => result.Status ?? result.status
            const messageOf = (result) => result.Message ?? result.message ?? result.ErrorCode ?? result.errorCode
            const returnedIds = new Set(requestResults.map(idOf).filter((id) => id !== undefined).map(String))
            suggestionIds.filter((id) => !returnedIds.has(String(id))).forEach((id) => {
              failures.push({ id, message: ['No acceptance result returned for this suggestion'] })
            })
            requestResults.forEach((result) => {
              const status = statusOf(result)?.toLowerCase()
              if (status !== 'accepted' && status !== 'alreadyprocessed') {
                failures.push({ id: idOf(result) ?? errorId, message: [messageOf(result) || 'Suggestion acceptance failed'] })
              }
            })
          }
        }
        catch (exception) {
          const errors = exception?.response?.data?.Errors;
          const messages = Array.isArray(errors) && errors.length > 0
            ? errors.map(({ Detail }) => Detail)
            : [exception?.message || String(exception)];
          suggestionIds.forEach((id) => {
            failures.push({ id, message: messages });
          });
        }

        completed += suggestionIds.length
        setNumberOf(completed)
        setProgress(totalItems ? (completed / totalItems) * 100 : 100)
        setLog(failures)

        if (n === (requests.length - 1)) {
          setInProgress(false)
          setFinished(true)
          callback?.({ succeeded: failures.length === 0, failures, results })
        }
      }
    }
    request()
  }, [])

  return (
    <React.Fragment>
      <S.Transition transition={transition}>
        <S.Wrapper
          finished={finished}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {
            inProgress &&
            <CircularProgress
              style={{ color: 'white' }}
              size={25}
              value={progress}
              variant="determinate"
            />
          }
          {
            finished &&
            <img
              alt="Círculo Indicando o Processamento da operação"
              src={CircleLine}
            />
          }
        </S.Wrapper>
      </S.Transition>
      <S.Container active={showTooltip}>
        <S.BeakBottom />
        <div className='text__container'>
          <p>{text}</p>
          <p>{numberOf} {intl.get('commons.table.of')} {totalItems}</p>
        </div>
        {(finished && getAnyFailed()) &&
          <S.ErrorLabel
            title={intl.get('commons.logs')}
            className='error-label'
            onClick={() => setShowLogModal(true)}
          >
            {intl.get('commons.seeMore')}
          </S.ErrorLabel>
        }
      </S.Container>
      <LogModal
        logs={log}
        open={showLogModal}
        close={() => closeLogModal()}
      />
    </React.Fragment >
  )
}

OperationProgress.propTypes = {
  text: PropTypes.string,
  requests: PropTypes.arrayOf(PropTypes.shape({
    body: PropTypes.object,
    method: PropTypes.string,
    API: PropTypes.string,
    errorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    suggestionIds: PropTypes.array,
  })),
  callback: PropTypes.func
}
